import grow2529ExperimentSummaryCopy from '~pricing/experiments/grow_2529_forms/copy/experimentSummaryCopy';
import grow2792ExperimentSummaryCopy from '~pricing/experiments/grow_2792_pnp_refresh_v1/copy/experimentSummaryCopy';

const EXPERIMENT_SUMMARY_COPY = {
  ...grow2529ExperimentSummaryCopy,
  ...grow2792ExperimentSummaryCopy,
};

export default EXPERIMENT_SUMMARY_COPY;
